import {
  addCachedAppLoadHashToUrl,
  endAndReportCachedAppPageLoadTimingEventAfterStyleAndLayout,
} from '@ms/yammer-page-route-telemetry';
import { reportError } from '@ms/yammer-telemetry';
import { basenameForTeamsBrandedExpApp, getRoutePathAndQueryFromUrl } from '@ms/yammer-web-support/dist/location';
import { notifyAppInitializationFailure } from '@ms/yammer-web-support/dist/metaOsHub';
import { getDeepLinkPath as getDeepLinkPathFromState } from 'state/teamsContext/selectors';

type TryHandleDeepLink = (isCachedApp: boolean, appLoadContextContentUrl?: string) => void;
export const tryHandleDeepLink: TryHandleDeepLink = (isCachedApp, appLoadContextContentUrl) => {
  const deepLinkPathWithQuery = getDeepLinkPathFromState();
  const appLoadContextContentPathWithQuery =
    appLoadContextContentUrl && getRoutePathAndQueryFromUrl(appLoadContextContentUrl);
  const redirectPathWithQuery = deepLinkPathWithQuery || appLoadContextContentPathWithQuery;
  const routePathWithQueryFromUrl = getRoutePathAndQueryFromUrl(location.href);
  const hasRedirect = !!redirectPathWithQuery && redirectPathWithQuery !== routePathWithQueryFromUrl;

  if (!hasRedirect) {
    if (isCachedApp) {
      endAndReportCachedAppPageLoadTimingEventAfterStyleAndLayout();
    }

    return;
  }

  const redirectUrl = `${basenameForTeamsBrandedExpApp}${redirectPathWithQuery}`;
  try {
    const redirectUrlWithCachedAppLoadHash = isCachedApp ? addCachedAppLoadHashToUrl(redirectUrl) : redirectUrl;
    history.replaceState(null, '', redirectUrlWithCachedAppLoadHash);
    window.dispatchEvent(new PopStateEvent('popstate'));
  } catch (error: unknown) {
    notifyAppInitializationFailure(error);
    reportError({
      error,
      eventProperties: {
        errorCode: 'TeamsDeepLinkHandleFailed',
      },
    });
  }
};
